import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CardAccountDetailsOutline from "../../sharedComponents/customIcons/CardAccountDetailsOutline";
import AppConstants from "../../common/AppConstants";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import CardAccountDetailsStarOutline from "../../sharedComponents/customIcons/CardAccountDetailsStarOutline";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  tab: {
    fontSize: theme.typography.pxToRem(12),
  },
  tabsColor: {
    '& button': {
      color: '#ffffff !important',
      backgroundColor: theme.palette.mode === 'dark'? theme.palette.background.default : theme.palette.primary.main,
    },
  },
  scrollButtonContainer: {
    backgroundColor: theme.palette.mode === 'dark'? theme.palette.background.default : theme.palette.primary.main,
    '& svg': {
      color: '#ffffff', // Optional: Change the color of the arrow icons themselves
    },
  },
}));


const FrontOfficeCoachesAppBar = (props) => {
  const classes = useStyles();

  return (
    <AppBar position="static" elevation={1}>
      <Tabs
        value={props.tabIndex}
        onChange={props.handleChange}
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        aria-label="profile tabs"
        className={classes.tabsColor}
         classes={{
          root: classes.scrollButtonContainer, // Apply custom background to the scroll button container
        }}
      >
        <Tab
          className={classes.tab}
          icon={<CardAccountDetailsOutline />}
          label={
            !props.isXsDown() && AppConstants.DASHBOARD_SECTION_TITLE.AllProfiles
          }
          {...props.a11yProps(0)}
        />
        <Tab
          className={classes.tab}
          icon={<CardAccountDetailsStarOutline />}
          label={
            !props.isXsDown() &&
            AppConstants.DASHBOARD_SECTION_TITLE.BookmarkedProfiles
          }
          {...props.a11yProps(1)}
        />
        <Tab
          className={classes.tab}
          icon={<QueueOutlinedIcon />}
          label={
            !props.isXsDown() &&
            AppConstants.DASHBOARD_SECTION_TITLE.RecentlyAddedProfiles
          }
          {...props.a11yProps(2)}
        />

        {props.foTabs && props.foTabs.length > 0 &&
          props.foTabs.map((val, ind) => {
            return (
              <Tab
                className={classes.tab}
                icon={<QueueOutlinedIcon />}
                label={                  
                  val.name
                }
                {...props.a11yProps(3 + parseInt(ind))}
              />)
          })
        }

      </Tabs>
    </AppBar>
  )
}

export default FrontOfficeCoachesAppBar;